import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useQuery } from '@apollo/client';

import {
  Card,
  ContainerChart,
  Loader,
  ErrorContainer,
  ErrorText,
} from './styles';
import { TYPE_QUESTIONS } from '../../constants';

import { GET_ANALYTICS_UNMODERATED } from './graphql';

import QuestionChart from '../question-types/question-chart';
import WrittenResponseChart from '../question-types/written-response-chart';
import VerticalChart from '../../../../../../core/analytics/vertical-chart-survey-and-unmoderated';
import VideoChart from '../question-types/video-chart';
import ImageChart from '../question-types/image-chart';

const AnalyticsQuestions = (props) => {
  const { segmentId, project } = props;

  const {
    data = {},
    errors,
    loading,
  } = useQuery(
    GET_ANALYTICS_UNMODERATED,
    {
      variables: {
        projectId: project.id,
        segmentId,
      },
      fetchPolicy: 'no-cache',
    },
  );
  const unmoderatedAnalytics = data?.analytics?.unmoderatedAnalytics;

  const handleChartComponent = (question) => {
    switch (question.questionType) {
      case TYPE_QUESTIONS.RANGE:
        return (
          <Card key={question.id}>
            <VerticalChart
              title="Rating Scale"
              color="#93DFFF"
              data={question}
              projectId={project.id}
            />
          </Card>
        );

      case TYPE_QUESTIONS.WRITTEN:
        return (
          <Card key={question.id}>
            <WrittenResponseChart
              title="Written Response"
              data={question}
              projectId={project.id}
            />
          </Card>
        );

      case TYPE_QUESTIONS.MULTIPLE_SELECT:
        return (
          <Card key={question.id}>
            <VerticalChart
              title="Multiple Selection"
              color="#A8BEF9"
              data={question}
            />
          </Card>
        );

      case TYPE_QUESTIONS.SINGLE_SELECT:
        return (
          <Card key={question.id}>
            <VerticalChart
              title="Single Selection"
              color="#82EBD4"
              data={question}
            />
          </Card>
        );

      case TYPE_QUESTIONS.TASK:
        return (
          <Card key={question.id}>
            <QuestionChart
              title="Task / Question"
              data={question}
              projectId={project.id}
            />
          </Card>
        );

      case TYPE_QUESTIONS.URL:
        return (
          <Card key={question.id}>
            <QuestionChart
              title="Link"
              data={question}
              projectId={project.id}
            />
          </Card>
        );

      case TYPE_QUESTIONS.IMAGE_SELECT:
        return (
          <Card key={question.id}>
            <ImageChart
              title="Image"
              data={question}
              projectId={project.id}
            />
          </Card>
        );

      case TYPE_QUESTIONS.AUDIO_VIDEO:
        return (
          <Card key={question.id}>
            <VideoChart
              title="Audio/Video"
              data={question}
              projectId={project.id}
            />
          </Card>
        );

      default:
        return null;
    }
  };

  if (loading) {
    return (
      <ContainerChart>
        <Loader data-loader="analytics-questions-loader" />
      </ContainerChart>
    );
  }

  if (errors) {
    return (
      <ErrorContainer>
        <ErrorText>
          Error loading data
        </ErrorText>
      </ErrorContainer>
    );
  }

  return (
    <ContainerChart>
      {!_.isEmpty(unmoderatedAnalytics) && unmoderatedAnalytics.map((question) => (
        handleChartComponent(question)
      ))}
    </ContainerChart>
  );
};

AnalyticsQuestions.propTypes = {
  segmentId: PropTypes.string,
  project: PropTypes.shape({
    id: PropTypes.string,
    surveys: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
};

AnalyticsQuestions.defaultProps = {
  segmentId: '',
};

export default AnalyticsQuestions;
